export const agents = [
  {
    id: 1,
    name: "Agent IA Vendeur",
    icon: "ri-shopping-bag-line",
    color: "#39FF14",
    category: "Vente",
    image: "https://public.readdy.ai/ai/img_res/540a54198f63ac422d4830883567d5f0.jpg",
    description: "Vente conversationnelle et qualification prospects automatique",
    features: [
      "Vente conversationnelle intelligente",
      "Qualification automatique des prospects",
      "Gestion des objections en temps réel",
      "Upsell et cross-sell optimisés"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-vendeur"
  },
  {
    id: 2,
    name: "Agent IA Service Client",
    icon: "ri-customer-service-2-line",
    color: "#00A8FF",
    category: "Support",
    image: "https://readdy.ai/api/search-image?query=AI%20customer%20service%20assistant%20with%20headset%20holographic%20chat%20bubbles%20and%20support%20icons%20bright%20blue%20accents%20modern%20help%20desk%20interface%20digital%20customer%20care%20technology%20clean%20professional%20background%2024%2F7%20service%20concept&width=400&height=256&seq=agent-service-002&orientation=landscape",
    description: "Support client automatisé disponible 24/7",
    features: [
      "Réponses automatiques instantanées",
      "Gestion complète du SAV",
      "Base de connaissances FAQ",
      "Suivi des commandes en temps réel"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-service-client"
  },
  {
    id: 3,
    name: "Agent IA Prise de RDV",
    icon: "ri-calendar-check-line",
    color: "#FF6B35",
    category: "Planification",
    image: "https://readdy.ai/api/search-image?query=AI%20appointment%20scheduling%20system%20with%20calendar%20interface%20holographic%20time%20slots%20and%20booking%20confirmations%20orange%20accents%20modern%20digital%20planner%20technology%20automated%20scheduling%20dashboard%20clean%20minimalist%20background%20professional%20business%20tool&width=400&height=256&seq=agent-rdv-003&orientation=landscape",
    description: "Gestion intelligente de vos rendez-vous",
    features: [
      "Synchronisation agenda automatique",
      "Qualification avant rendez-vous",
      "Rappels automatiques personnalisés",
      "Gestion des annulations et reports"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-prise-rdv"
  },
  {
    id: 4,
    name: "Agent IA Support Technique",
    icon: "ri-tools-line",
    color: "#9D4EDD",
    category: "Technique",
    image: "https://readdy.ai/api/search-image?query=AI%20technical%20support%20system%20with%20tools%20icons%20troubleshooting%20interface%20and%20diagnostic%20displays%20purple%20accents%20modern%20tech%20support%20dashboard%20digital%20repair%20assistance%20holographic%20code%20snippets%20clean%20professional%20background&width=400&height=256&seq=agent-tech-004&orientation=landscape",
    description: "Assistance technique experte instantanée",
    features: [
      "Aide produit détaillée",
      "Résolution de problèmes guidée",
      "Tutoriels interactifs personnalisés",
      "Escalade vers experts si nécessaire"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-support-technique"
  },
  {
    id: 5,
    name: "Agent IA Marketing",
    icon: "ri-megaphone-line",
    color: "#FF006E",
    category: "Marketing",
    image: "https://readdy.ai/api/search-image?query=AI%20marketing%20automation%20system%20with%20megaphone%20icons%20campaign%20analytics%20and%20engagement%20metrics%20pink%20magenta%20accents%20modern%20digital%20marketing%20dashboard%20social%20media%20graphs%20holographic%20content%20creation%20tools%20clean%20professional%20background&width=400&height=256&seq=agent-marketing-005&orientation=landscape",
    description: "Création de campagnes marketing automatisées",
    features: [
      "Génération de campagnes complètes",
      "Idées de contenu créatives",
      "Emails marketing personnalisés",
      "Scripts publicitaires optimisés"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-marketing"
  },
  {
    id: 6,
    name: "Agent IA Réseaux Sociaux",
    icon: "ri-chat-smile-3-line",
    color: "#FFB800",
    category: "Social Media",
    image: "https://readdy.ai/api/search-image?query=AI%20social%20media%20management%20system%20with%20chat%20bubbles%20emoji%20reactions%20and%20engagement%20icons%20golden%20yellow%20accents%20modern%20social%20network%20dashboard%20holographic%20likes%20comments%20shares%20clean%20professional%20background%20community%20management%20interface&width=400&height=256&seq=agent-social-006&orientation=landscape",
    description: "Gestion automatisée de vos réseaux sociaux",
    features: [
      "Réponses automatiques aux DM",
      "Modération intelligente des commentaires",
      "FAQ Instagram et Facebook",
      "Engagement communautaire optimisé"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-reseaux-sociaux"
  },
  {
    id: 7,
    name: "Agent IA RH / Recrutement",
    icon: "ri-user-search-line",
    color: "#06FFA5",
    category: "Ressources Humaines",
    image: "https://readdy.ai/api/search-image?query=AI%20recruitment%20system%20with%20candidate%20profiles%20resume%20scanning%20and%20interview%20scheduling%20interface%20turquoise%20green%20accents%20modern%20HR%20technology%20dashboard%20holographic%20user%20icons%20talent%20acquisition%20tools%20clean%20professional%20background&width=400&height=256&seq=agent-rh-007&orientation=landscape",
    description: "Recrutement intelligent et automatisé",
    features: [
      "Pré-qualification des candidats",
      "Questions d'entretien automatiques",
      "Tri et analyse de CV",
      "Planification des entretiens"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-rh-recrutement"
  },
  {
    id: 8,
    name: "Agent IA Formation Client",
    icon: "ri-graduation-cap-line",
    color: "#4CC9F0",
    category: "Formation",
    image: "https://readdy.ai/api/search-image?query=AI%20training%20and%20onboarding%20system%20with%20graduation%20cap%20icons%20interactive%20tutorials%20and%20progress%20tracking%20cyan%20blue%20accents%20modern%20e-learning%20platform%20dashboard%20holographic%20educational%20content%20clean%20professional%20background%20knowledge%20transfer%20interface&width=400&height=256&seq=agent-formation-008&orientation=landscape",
    description: "Onboarding et formation automatisés",
    features: [
      "Onboarding automatique personnalisé",
      "Guides interactifs pas à pas",
      "Formation produits complète",
      "Suivi de progression"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-formation-client"
  },
  {
    id: 9,
    name: "Agent IA Analyse Business",
    icon: "ri-line-chart-line",
    color: "#F72585",
    category: "Analytics",
    image: "https://readdy.ai/api/search-image?query=AI%20business%20analytics%20system%20with%20charts%20graphs%20and%20data%20visualization%20dashboard%20pink%20red%20accents%20modern%20business%20intelligence%20interface%20holographic%20statistics%20predictive%20analytics%20metrics%20clean%20professional%20background%20insights%20dashboard&width=400&height=256&seq=agent-analytics-009&orientation=landscape",
    description: "Analyse de données et insights business",
    features: [
      "Analyse données clients avancée",
      "Suggestions d'optimisation",
      "Rapports automatiques détaillés",
      "Prédictions et tendances"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-analyse-business"
  },
  {
    id: 10,
    name: "Agent IA Standard Téléphonique",
    icon: "ri-phone-line",
    color: "#7209B7",
    category: "Téléphonie",
    image: "https://readdy.ai/api/search-image?query=AI%20phone%20system%20with%20telephone%20icons%20voice%20wave%20patterns%20and%20call%20routing%20interface%20deep%20purple%20accents%20modern%20telephony%20dashboard%20holographic%20voice%20assistant%20technology%20clean%20professional%20background%20automated%20receptionist%20system&width=400&height=256&seq=agent-phone-010&orientation=landscape",
    description: "Standard téléphonique intelligent avec voix IA",
    features: [
      "Réponse vocale IA naturelle",
      "Transfert intelligent vers humains",
      "Prise de messages détaillée",
      "Disponibilité 24/7"
    ],
    price: {
      basic: 99,
      pro: 199,
      elite: 399
    },
    slug: "agent-standard-telephonique"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Depuis que nous avons activé l'Agent IA Vendeur, nos conversions ont augmenté de 340%. C'est comme avoir 10 commerciaux d'élite qui ne dorment jamais.",
    author: "Sophie Mercier",
    role: "Directrice Commerciale",
    company: "TechFlow Solutions",
    logo: "https://readdy.ai/api/search-image?query=modern%20tech%20company%20logo%20minimalist%20blue%20geometric%20abstract%20design%20clean%20professional%20corporate%20identity&width=120&height=120&seq=testimonial-logo-1&orientation=squarish"
  },
  {
    id: 2,
    quote: "Notre service client traite maintenant 5000 demandes par jour avec seulement 2 personnes. L'Agent IA gère 92% des requêtes automatiquement. Un ROI incroyable.",
    author: "Marc Dubois",
    role: "CEO",
    company: "E-Commerce Pro",
    logo: "https://readdy.ai/api/search-image?query=ecommerce%20brand%20logo%20modern%20minimalist%20shopping%20cart%20icon%20professional%20clean%20design%20corporate%20identity&width=120&height=120&seq=testimonial-logo-2&orientation=squarish"
  },
  {
    id: 3,
    quote: "L'Agent IA RH a révolutionné notre recrutement. Nous avons réduit le temps de pré-qualification de 80% et trouvons des candidats parfaits en quelques heures.",
    author: "Amélie Laurent",
    role: "DRH",
    company: "Innovation Labs",
    logo: "https://readdy.ai/api/search-image?query=innovation%20lab%20logo%20futuristic%20abstract%20geometric%20modern%20professional%20clean%20corporate%20identity%20technology&width=120&height=120&seq=testimonial-logo-3&orientation=squarish"
  }
];

export const stats = [
  {
    value: "500+",
    label: "Entreprises Clientes"
  },
  {
    value: "2M+",
    label: "Conversations Traitées"
  },
  {
    value: "92%",
    label: "Taux de Satisfaction"
  },
  {
    value: "24/7",
    label: "Disponibilité"
  }
];

export const useCases = [
  {
    sector: "E-Commerce",
    icon: "ri-shopping-cart-line",
    agents: ["Agent Vendeur", "Agent Service Client", "Agent Marketing"],
    result: "+340% de conversions"
  },
  {
    sector: "Services B2B",
    icon: "ri-briefcase-line",
    agents: ["Agent Prise de RDV", "Agent Vendeur", "Agent Formation"],
    result: "-65% coûts acquisition"
  },
  {
    sector: "Tech & SaaS",
    icon: "ri-code-box-line",
    agents: ["Agent Support Technique", "Agent Formation", "Agent Analyse"],
    result: "92% satisfaction client"
  },
  {
    sector: "Santé & Bien-être",
    icon: "ri-heart-pulse-line",
    agents: ["Agent Prise de RDV", "Agent Service Client", "Agent Standard"],
    result: "5000 RDV/mois automatisés"
  }
];

export const detailedCaseStudies = [
  {
    id: 1,
    company: "TechStore France",
    industry: "E-commerce Électronique",
    logo: "ri-store-3-line",
    size: "PME - 45 employés",
    location: "Paris, France",
    duration: "6 mois",
    agentUsed: "Agent IA Vendeur",
    image: "https://readdy.ai/api/search-image?query=modern%20electronics%20store%20interior%20with%20digital%20displays%20showing%20smartphones%20tablets%20and%20computers%20clean%20minimalist%20design%20with%20bright%20lighting%20professional%20retail%20environment&width=800&height=600&seq=techstore001&orientation=landscape",
    context: {
      title: "Contexte Initial",
      description: "TechStore France, spécialisée dans la vente d'électronique grand public, faisait face à une croissance rapide de son trafic web (+250% en 1 an) mais peinait à convertir ces visiteurs en clients. Avec seulement 3 conseillers disponibles, l'entreprise ne pouvait répondre qu'à 15% des demandes en temps réel.",
      challenges: [
        "500+ demandes quotidiennes non traitées",
        "Taux de conversion stagnant à 1.2%",
        "Temps de réponse moyen de 4h30",
        "Panier moyen de 180€ en baisse",
        "78% d'abandon de panier"
      ]
    },
    solution: {
      title: "Solution Déployée",
      description: "Déploiement de l'Agent IA Vendeur formé sur l'intégralité du catalogue (2,500 produits), configuré pour gérer les questions techniques, comparer les produits, et guider vers l'achat avec des recommandations personnalisées.",
      implementation: [
        "Formation de l'agent sur 2,500 fiches produits",
        "Intégration avec le système de gestion des stocks",
        "Configuration des scénarios de vente et objections",
        "Tests A/B sur 2 semaines avant déploiement complet",
        "Formation de l'équipe sur la supervision de l'agent"
      ],
      timeline: "Déploiement complet en 3 semaines"
    },
    results: {
      title: "Résultats Mesurables",
      metrics: [
        {
          label: "Taux de conversion",
          before: "1.2%",
          after: "4.6%",
          change: "+280%",
          icon: "ri-arrow-up-line",
          color: "#39FF14"
        },
        {
          label: "Temps de réponse",
          before: "4h30",
          after: "8 secondes",
          change: "-99.9%",
          icon: "ri-time-line",
          color: "#00A8FF"
        },
        {
          label: "Panier moyen",
          before: "180€",
          after: "340€",
          change: "+89%",
          icon: "ri-shopping-cart-line",
          color: "#FF6B35"
        },
        {
          label: "Coûts support",
          before: "12,500€/mois",
          after: "4,200€/mois",
          change: "-65%",
          icon: "ri-money-euro-circle-line",
          color: "#9D4EDD"
        },
        {
          label: "Conversations traitées",
          before: "450/jour",
          after: "3,200/jour",
          change: "+611%",
          icon: "ri-chat-3-line",
          color: "#FF006E"
        },
        {
          label: "Satisfaction client",
          before: "3.2/5",
          after: "4.7/5",
          change: "+47%",
          icon: "ri-star-fill",
          color: "#FFB800"
        }
      ],
      financial: {
        investment: "199€/mois",
        monthlySavings: "8,300€",
        additionalRevenue: "45,000€/mois",
        roi: "22,550%",
        paybackPeriod: "2 jours"
      },
      operational: [
        "92% des demandes résolues automatiquement",
        "Disponibilité 24/7 sans coût additionnel",
        "3 conseillers recentrés sur les ventes complexes",
        "Réduction de 71% des abandons de panier",
        "Augmentation de 156% des ventes croisées"
      ]
    },
    testimonial: {
      quote: "En 3 mois, notre taux de conversion a triplé. L'agent répond instantanément aux questions techniques et guide les clients vers l'achat. Nos conseillers se concentrent maintenant sur les cas complexes et les ventes B2B. Le ROI est tout simplement extraordinaire.",
      author: "Sophie Martin",
      role: "Directrice E-commerce",
      avatar: "SM"
    },
    keyTakeaways: [
      "Réponse instantanée = conversion multipliée par 3",
      "Recommandations personnalisées augmentent le panier moyen",
      "Libération de l'équipe pour les tâches à haute valeur",
      "ROI positif dès les premières semaines"
    ]
  },
  {
    id: 2,
    company: "Clinique Santé Plus",
    industry: "Santé & Bien-être",
    logo: "ri-heart-pulse-line",
    size: "Clinique privée - 12 praticiens",
    location: "Lyon, France",
    duration: "4 mois",
    agentUsed: "Agent IA Prise de RDV",
    image: "https://readdy.ai/api/search-image?query=modern%20medical%20clinic%20reception%20area%20with%20clean%20white%20interior%20comfortable%20waiting%20room%20professional%20healthcare%20environment%20bright%20natural%20lighting&width=800&height=600&seq=clinique001&orientation=landscape",
    context: {
      title: "Contexte Initial",
      description: "Clinique Santé Plus, regroupant 12 praticiens spécialisés, perdait 40% des appels entrants faute de disponibilité de la secrétaire médicale. Les patients frustrés se tournaient vers la concurrence, entraînant une perte de revenus estimée à 25,000€/mois.",
      challenges: [
        "200+ appels manqués par semaine",
        "1 secrétaire pour 12 praticiens",
        "Gestion manuelle de 6 agendas différents",
        "Taux de no-show de 18%",
        "Impossibilité de prendre RDV en dehors des heures d'ouverture"
      ]
    },
    solution: {
      title: "Solution Déployée",
      description: "Implémentation de l'Agent IA Prise de RDV avec synchronisation en temps réel des agendas de tous les praticiens, qualification automatique des demandes, et système de rappels intelligents pour réduire les absences.",
      implementation: [
        "Synchronisation avec les 6 logiciels d'agenda différents",
        "Configuration des disponibilités et spécialités",
        "Mise en place du système de qualification patient",
        "Intégration des rappels SMS et email automatiques",
        "Formation de l'équipe médicale"
      ],
      timeline: "Déploiement en 2 semaines"
    },
    results: {
      title: "Résultats Mesurables",
      metrics: [
        {
          label: "RDV pris automatiquement",
          before: "120/semaine",
          after: "480/semaine",
          change: "+300%",
          icon: "ri-calendar-check-line",
          color: "#FF6B35"
        },
        {
          label: "Taux de no-show",
          before: "18%",
          after: "4%",
          change: "-78%",
          icon: "ri-user-unfollow-line",
          color: "#39FF14"
        },
        {
          label: "Temps secrétariat",
          before: "35h/semaine",
          after: "8h/semaine",
          change: "-77%",
          icon: "ri-time-line",
          color: "#00A8FF"
        },
        {
          label: "Taux de remplissage",
          before: "68%",
          after: "94%",
          change: "+38%",
          icon: "ri-calendar-2-line",
          color: "#9D4EDD"
        },
        {
          label: "Revenus mensuels",
          before: "85,000€",
          after: "142,000€",
          change: "+67%",
          icon: "ri-money-euro-circle-line",
          color: "#FF006E"
        },
        {
          label: "Satisfaction patients",
          before: "3.8/5",
          after: "4.9/5",
          change: "+29%",
          icon: "ri-emotion-happy-line",
          color: "#FFB800"
        }
      ],
      financial: {
        investment: "199€/mois",
        monthlySavings: "4,800€",
        additionalRevenue: "57,000€/mois",
        roi: "28,442%",
        paybackPeriod: "1 jour"
      },
      operational: [
        "Prise de RDV 24/7 sans interruption",
        "Réduction de 78% des no-shows grâce aux rappels",
        "Secrétaire recentrée sur l'accueil physique",
        "Optimisation automatique des plannings",
        "Gestion de 6 agendas simultanément"
      ]
    },
    testimonial: {
      quote: "Nous ne perdons plus un seul patient par manque de disponibilité. L'agent gère les prises de RDV 24/7, envoie des rappels automatiques, et nos no-shows ont chuté de 78%. Notre secrétaire peut enfin se concentrer sur l'accueil et le relationnel. C'est une révolution pour notre clinique.",
      author: "Dr. Jean Dupont",
      role: "Directeur Médical",
      avatar: "JD"
    },
    keyTakeaways: [
      "Disponibilité 24/7 = zéro opportunité manquée",
      "Rappels automatiques divisent les absences par 4",
      "Optimisation des plannings augmente les revenus de 67%",
      "Équipe libérée pour les tâches à valeur humaine"
    ]
  },
  {
    id: 3,
    company: "SaaS Academy",
    industry: "Formation en ligne SaaS",
    logo: "ri-graduation-cap-line",
    size: "Scale-up - 28 employés",
    location: "Bordeaux, France",
    duration: "5 mois",
    agentUsed: "Agent IA Support Technique",
    image: "https://readdy.ai/api/search-image?query=modern%20online%20learning%20platform%20office%20with%20multiple%20computer%20screens%20showing%20educational%20content%20collaborative%20workspace%20bright%20contemporary%20design%20technology%20environment&width=800&height=600&seq=saasacademy001&orientation=landscape",
    context: {
      title: "Contexte Initial",
      description: "SaaS Academy, plateforme de formation en ligne avec 8,500 utilisateurs actifs, faisait face à une explosion des demandes de support technique. L'équipe de 4 personnes était submergée, entraînant des délais de réponse de 24h et un taux de churn de 12%.",
      challenges: [
        "850+ tickets de support par semaine",
        "Temps de réponse moyen de 24h",
        "4 personnes en support pour 8,500 utilisateurs",
        "Taux de churn de 12% lié au support",
        "Questions répétitives (70% identiques)"
      ]
    },
    solution: {
      title: "Solution Déployée",
      description: "Déploiement de l'Agent IA Support Technique formé sur toute la documentation produit, les tutoriels vidéo, et les 5,000 tickets historiques pour résoudre instantanément les problèmes courants et guider les utilisateurs pas à pas.",
      implementation: [
        "Formation sur 200+ articles de documentation",
        "Analyse de 5,000 tickets historiques",
        "Création de 150 tutoriels interactifs guidés",
        "Intégration avec le système de ticketing",
        "Configuration de l'escalade vers humains"
      ],
      timeline: "Déploiement en 4 semaines"
    },
    results: {
      title: "Résultats Mesurables",
      metrics: [
        {
          label: "Tickets résolus auto",
          before: "0%",
          after: "87%",
          change: "+87%",
          icon: "ri-checkbox-circle-line",
          color: "#39FF14"
        },
        {
          label: "Temps de réponse",
          before: "24h",
          after: "12 secondes",
          change: "-99.9%",
          icon: "ri-time-line",
          color: "#00A8FF"
        },
        {
          label: "Taux de churn",
          before: "12%",
          after: "3.5%",
          change: "-71%",
          icon: "ri-user-unfollow-line",
          color: "#FF6B35"
        },
        {
          label: "Coûts support",
          before: "18,000€/mois",
          after: "6,500€/mois",
          change: "-64%",
          icon: "ri-money-euro-circle-line",
          color: "#9D4EDD"
        },
        {
          label: "Satisfaction support",
          before: "2.9/5",
          after: "4.8/5",
          change: "+66%",
          icon: "ri-star-fill",
          color: "#FF006E"
        },
        {
          label: "Revenus conservés",
          before: "-",
          after: "95,000€/mois",
          change: "Nouveau",
          icon: "ri-safe-line",
          color: "#FFB800"
        }
      ],
      financial: {
        investment: "199€/mois",
        monthlySavings: "11,500€",
        additionalRevenue: "95,000€/mois (churn évité)",
        roi: "53,366%",
        paybackPeriod: "Moins de 1 jour"
      },
      operational: [
        "87% des tickets résolus automatiquement",
        "Équipe support recentrée sur les cas complexes",
        "Base de connaissances enrichie en continu",
        "Tutoriels interactifs disponibles 24/7",
        "Réduction de 71% du taux de churn"
      ]
    },
    testimonial: {
      quote: "Notre support était notre point faible, c'est devenu notre force. L'agent résout 87% des demandes instantanément avec des tutoriels interactifs. Notre équipe gère maintenant les cas complexes et améliore le produit. Le churn a chuté de 71%, ce qui représente 95,000€ de revenus conservés chaque mois.",
      author: "Julien Moreau",
      role: "CEO & Co-fondateur",
      avatar: "JM"
    },
    keyTakeaways: [
      "Résolution instantanée améliore drastiquement la satisfaction",
      "87% d'automatisation libère l'équipe pour l'innovation",
      "Réduction du churn = impact direct sur les revenus",
      "ROI exceptionnel grâce aux revenus conservés"
    ]
  }
];
